import { render, staticRenderFns } from "./FilesSearch.vue?vue&type=template&id=804cd72c&"
import script from "./FilesSearch.vue?vue&type=script&lang=js&"
export * from "./FilesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilesSearch.vue"
export default component.exports